<button
  class="avatar-base"
  [ngClass]="!border ? 'avatar-no-border' : ''"
  (click)="onClicked()"
  type="button"
  [attr.aria-label]="'Avatar for ' + name"
>
  @if (!!src) {
    <img src="{{ src }}" alt="Avatar" class="avatar-img" />
  }
  @if (!src) {
    <div class="avatar-text">{{ getWords(name) }}</div>
  }
  <div class="avatar-name">
    <div class="name">{{ name }}</div>
    <div class="text">
      <small>{{ label }}</small>
    </div>
  </div>
  @if (!!icon) {
    <button
      [ngClass]="!toggleIcon ? icon : iconSecondary ? iconSecondary : icon"
      class="icon-small-medium pi"
      (click)="onClickedAction()"
      type="button"
      [attr.aria-label]="'Action button for ' + name"
    ></button>
  }
</button>
